import {CardContent, CardHeader, Chip, FormControlLabel, Switch} from "@mui/material";
import Grid from "@mui/material/Grid/Grid";
import {Filter} from "@variocube/app-ui";
import {useQuery} from "@tanstack/react-query";
import React from "react";
import {useLocalization} from "@smalox/shared";
import {useTenantApi} from "../../api/tenant";
import {queryKeys} from "../../utils/queryKeys";
import {TenantSelect} from "../TenantSelect";

interface SubscriptionFilterProps {
	value: {
		search?: string;
		tenantId?: string;
		planId?: number;
		active?: boolean;
	};
	onChange: (value: any) => void;
}

export function SubscriptionFilter({value, onChange}: SubscriptionFilterProps) {
	const {t, s} = useLocalization();
	const {getTenant} = useTenantApi();

	// Resolve the selected tenant so the picker and chip can show its name.
	const {data: tenant} = useQuery(
		["tenant", value.tenantId],
		() => getTenant(value.tenantId!),
		{enabled: Boolean(value.tenantId)},
	);

	return (
		<Filter
			label={t("filter.title")}
			enableSearch
			onSearch={search => onChange({...value, search: search || undefined})}
			active={[
				value.search && (
					<Chip
						key="search"
						label={`${t("filter.search")}: ${value.search}`}
						onDelete={() => onChange({...value, search: undefined})}
					/>
				),
				value.tenantId && (
					<Chip
						key="tenantId"
						label={`${t("subscriptions.tenant")}: ${tenant?.name ?? value.tenantId}`}
						onDelete={() => onChange({...value, tenantId: undefined})}
					/>
				),
				value.active !== undefined && (
					<FormControlLabel
						key="active"
						control={
							<Switch
								checked={value.active ?? true}
								onChange={(_, checked) => onChange({...value, active: checked})}
								size="small"
							/>
						}
						label={t("subscriptions.status.active")}
					/>
				),
			]}
			labels={s("filter")}
		>
			<CardContent>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6} md={4}>
						<CardHeader title={t("subscriptions.tenant")} />
						<CardContent>
							<TenantSelect
								value={tenant ?? null}
								onChange={tenant => onChange({...value, tenantId: tenant?.id})}
								fullWidth
							/>
						</CardContent>
					</Grid>
				</Grid>
			</CardContent>
		</Filter>
	);
}
